import { useMemo } from 'react';
import { Puzzle } from '../../shared/types';
import { CellState, GameState } from '../game';
import { Cell } from '../drill';
import { Board } from './Board';

/**
 * A board rendered for looking at — queens, a marked square and dashed rings are all passed in.
 *
 * Shared by the speed drill and its session history so a board looks the same wherever it is
 * shown; both draw it through the game's own `Board`, which is what keeps region borders and the
 * palette identical to a real puzzle.
 */
export function StaticBoard({ regions, queens, mark, ringed }: {
  regions: string[][];
  queens?: readonly Cell[];
  /** Drawn as an ✕ — where a wrong queen went. */
  mark?: Cell | null;
  /** Cell keys ("r,c") drawn as *given* (dashed) rather than placed. */
  ringed?: Set<string> | null;
}) {
  const size = regions.length;
  const puzzle = useMemo<Puzzle>(
    () => ({ id: -1, name: 'Drill', size, colorRegions: regions }),
    [regions, size],
  );
  const state = useMemo<GameState>(() => {
    const board: CellState[][] = Array.from({ length: size }, () => Array<CellState>(size).fill(null));
    queens?.forEach(q => { board[q.row][q.col] = 'queen'; });
    if (mark && board[mark.row][mark.col] === null) board[mark.row][mark.col] = 'X';
    return { board, undoStack: [], events: [], startTime: 0, elapsedAtComplete: null };
  }, [size, queens, mark]);

  return <Board puzzle={puzzle} state={state} onStateChange={() => {}} readOnly revealed={ringed ?? null} />;
}
